import React, { useEffect, useMemo, useState } from "react";
import { getTutorialByPage } from "../../HTTP/user";

function decodeEscapedHtml(raw) {
    if (!raw || typeof raw !== "string") return "";
    const decoder = document.createElement("textarea");
    decoder.innerHTML = raw;
    return decoder.value;
}

function sanitizeHtml(html) {
    if (!html) return "";
    return html
        .replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, "")
        .replace(/\son\w+="[^"]*"/gi, "")
        .replace(/\son\w+='[^']*'/gi, "")
        .replace(/javascript:/gi, "");
}

export default function TutorialWidget() {
    const [loading, setLoading] = useState(true);
    const [open, setOpen] = useState(false);
    const [tutorial, setTutorial] = useState(null);

    const pagePath = useMemo(() => window.location.pathname, []);

    useEffect(() => {
        let mounted = true;
        const fetchTutorial = async () => {
            try {
                setLoading(true);
                const response = await getTutorialByPage(pagePath);
                if (!mounted) return;
                if (response && (response.content || response.context)) {
                    setTutorial(response);
                } else {
                    setTutorial(null);
                }
            } catch (error) {
                if (mounted) {
                    setTutorial(null);
                }
            } finally {
                if (mounted) {
                    setLoading(false);
                }
            }
        };

        fetchTutorial();
        return () => {
            mounted = false;
        };
    }, [pagePath]);

    const decodedContent = sanitizeHtml(
        decodeEscapedHtml(tutorial?.content || tutorial?.context || "")
    );

    return (
        <>
            <button
                type="button"
                onClick={() => setOpen(true)}
                disabled={loading || !tutorial}
                className={`rounded text-white mr-2 ${
                    loading || !tutorial ? "bg-gray-400 cursor-not-allowed" : "bg-[#009AAD] hover:bg-[#007b8a]"
                }`}
                title={tutorial ? "Voir le tutoriel de la page" : "Aucun tutoriel disponible"}
            >
                Tutoriel
            </button>

            {open && tutorial && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4"
                    onClick={() => setOpen(false)}
                >
                    <div
                        className="bg-white rounded-lg w-full max-w-3xl max-h-[80vh] overflow-y-auto p-4"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <div className="flex items-center justify-between mb-4">
                            <h2 className="text-xl font-bold">Tutoriel</h2>
                            <button
                                type="button"
                                onClick={() => setOpen(false)}
                                className="px-3 py-1 bg-gray-200 hover:bg-gray-300 rounded"
                            >
                                Fermer
                            </button>
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: decodedContent }} />
                    </div>
                </div>
            )}
        </>
    );
}
